import { Surface } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

const UniSurface = withUnistyles(Surface)

export default UniSurface
